import { AppUI } from '@seedlang/state';
import React from 'react';

class WhitelabelLogo extends React.Component {

  render() {
    if (!AppUI.site?.image) {
      return null;
    }

    return (
      <div>
        <img
          src={AppUI.site.image.url}
          alt={`${AppUI.site.teamName} Logo`}
          style={{
            maxHeight: '45px',
          }}
        />
      </div>
    );
  }
}

export default WhitelabelLogo;
